import {darken, lighten} from '@mui/system';
import {SEVERITIES} from '../constants';
import type {SeverityColors, Theme} from '../types';

export const getSeverityColors = (theme: Theme) => {
	const light = theme.palette.mode === 'light';
	const getBackgroundColor = light ? darken : lighten;
	const severities: SeverityColors = {} as SeverityColors;
	SEVERITIES.forEach((key) => {
		severities[key] =
			key === 'default'
				? {
						default: theme.palette.secondary.main,
						text: theme.palette.secondary.contrastText,
						hover: getBackgroundColor(theme.palette.secondary.main, 0.05),
					}
				: {
						default: theme.palette[key].main,
						text: theme.palette[key].contrastText,
						hover: getBackgroundColor(theme.palette[key].main, 0.05),
					};
	});
	return severities;
};
